export enum RouteName {
  DASHBOARD = '/selvbetjening',
  DASHBOARD_CHARGERS_OVERVIEW = '/selvbetjening/ladere',
  DASHBOARD_CHARGERS = '/selvbetjening/ladere/forbrug',
  DASHBOARD_INVOICES = '/selvbetjening/regninger',
  DASHBOARD_PERMISSIONS = '/selvbetjening/samtykker',
  DASHBOARD_PROFILE = '/selvbetjening/profil',
  DASHBOARD_USAGE = '/selvbetjening/elforbrug',
  DASHBOARD_CUSTOMER_BENEFITS = '/selvbetjening/kundefordele',
  DASHBOARD_PRODUCT_MIGRATION = '/selvbetjening/produktskift',
  DASHBOARD_SETTINGS = '/selvbetjening/indstillinger',
  DASHBOARD_STATUS = '/selvbetjening/driftstatus',
  LOGIN = '/login'
}
